/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Finish_Confirm_Warn_DecksInputs */



/**
* | output |
* | --- |
* | "{count} player(s) have not submitted a decklist" |
*
* @param {Finish_Confirm_Warn_DecksInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_warn_decks = /** @type {((inputs: Finish_Confirm_Warn_DecksInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_Warn_DecksInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueur(s) n'ont pas soumis de decklist`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugador/es no han enviado una decklist`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogador/es não enviaram uma decklist`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatore/i non hanno inviato una decklist`)
	return /** @type {LocalizedString} */ (`${i?.count} player(s) have not submitted a decklist`)
});